module.exports = __webpack_public_path__ + "img/qrCode_02.0f582d19.jpg";